import React, { Component } from 'react';
import './myutils';
import { translate } from 'react-admin';
import { configAPI } from './config';
import HeJxlText from './res/HeJxlText';
import axios from 'axios';
import jexcel from "jexcel";
import "../node_modules/jexcel/dist/jexcel.css";
import Button from '@material-ui/core/Button';
import { AppBar, Toolbar, Typography } from '@material-ui/core';

class Customers extends Component {

    constructor(props) {
        super(props);
        this.wrapper = React.createRef();

        this.state = {
            optionsXL: {
                text: HeJxlText,
                data: [[]],
                columns: [{ title: HeJxlText.id, width: 100 }, { title: HeJxlText.active, width: 100 },
                { title: HeJxlText.pname, width: 100 }, { title: HeJxlText.fname, width: 100 },
                { title: HeJxlText.email, width: 100 }, { title: HeJxlText.organization, width: 100 }],
                minDimensions: [6, 6]
            }
        }
    }

    componentDidMount() {
        const request = new Request(configAPI.api.prod + '/DownloadFile?&path=ivr2:/EnterID/ListAllInformation.ini&token=' + sessionStorage.B.encodeDecode(), {
            headers: new Headers({
                'Content-Type': 'text/json'
            }),
            method: 'GET'
        });
        fetch(request).then(data => data.text())
            .then(data => {
                if (data !== 'Requested file does not exist') this.updateTable(data);
                else this.JXL = jexcel(this.wrapper.current, this.state.optionsXL);
            })
    }


    handleSubmit = () => {
        var uploadContents = this.table2CSV();
        const blob = new Blob([uploadContents], { type: 'text/plain' });
        var data = new FormData();
        data.append('upload', blob, 'ListAllInformation.ini');
        data.append("token", sessionStorage.B.encodeDecode());
        data.append("path", 'ivr/EnterID/ListAllInformation.ini');
        console.log(data);
        axios.post(configAPI.api.prod + 'UploadFile', data).then(function (resp) {
            return true;
        });
    }

    table2CSV() {
        var data = this.JXL.getData();
        var cols = this.JXL.getHeaders();
        var csv = cols + '\n';
        data.forEach(row => {
            row.forEach(cell => {
                csv += cell + ',';
            });
            csv = csv.slice(0, -1) + '\n';
        });
        csv = csv.slice(0, -3)
        return csv;
    }

    updateTable(csv) {
        var csvRows = csv.split('\n');
        var csvCols = csvRows[0].split(',');
        var columns = [];
        var rows = [];
        csvCols.forEach((col, i) => {
            columns.push({ title: col, width: 100 })
        });

        csvRows.shift();
        csvRows.forEach(csvrow => {
            var row = csvrow.split(',');
            rows.push(row);
        });

        this.setState({
            optionsXL: {
                text: HeJxlText,
                data: rows,
                columns: columns,
                minDimensions: [columns.length, rows.length]
            }
        });
        this.JXL = jexcel(this.wrapper.current, this.state.optionsXL);
    }


    render() {
        const { translate } = this.props;
        return (<div>
            <AppBar position="static" color="default" elevation={1}>
                <Toolbar>
                    <Typography variant="title" color="inherit">
                        {translate('resources.Customers.name')}
                    </Typography>
                </Toolbar>
            </AppBar>
                <Button onClick={() => this.JXL.insertRow()} color="primary">
                    {translate('ra.action.insertRow')}
                </Button>
                <Button onClick={() => this.JXL.insertColumn()} color="primary">
                    {translate('ra.action.insertColumn')}
                </Button>
                <Button onClick={this.handleSubmit} color="primary">
                    {translate('ra.action.save')}
                </Button>
                <br />
                <div ref={this.wrapper} />
            </div>);
    }
}

export default (translate(Customers)); 